var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTc02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1030",
    "data-name": "Groupe 1030",
    transform: "translate(0.179)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-0.179)",
    fill: "#d4eacd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-cloud",
    "data-name": "Icon awesome-cloud",
    d: "M13.858,7.266A2.478,2.478,0,0,0,11.549,3.9a2.462,2.462,0,0,0-1.374.418,4.125,4.125,0,0,0-7.7,2.057c0,.07,0,.139.005.209A3.713,3.713,0,0,0,3.712,13.8H13.2a3.3,3.3,0,0,0,.66-6.532Z",
    transform: "translate(6.751 6.975)",
    fill: "#43b02a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc02);
export default __webpack_public_path__ + "static/media/TC02.9205f777b4e5b1e60cc8aa39d0314909.svg";
export { ForwardRef as ReactComponent };